import React, { useState, useEffect } from 'react';
import NavbarAdminMex from '../components/navbar';
import './recargas.css';

const AdminRecargas = () => {
    const [recargas, setRecargas] = useState([]);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    useEffect(() => {
        fetchRecargas();
    }, []);

    const fetchRecargas = async () => {
        try {
            const userId = localStorage.getItem('usuario_id');
            const response = await fetch(`https://api.99envios.app/api/online/recargas/ver-recargas/${userId}`);
            const data = await response.json();
            // Ensure we're setting an array, even if empty
            setRecargas(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error('Error fetching recargas:', error);
            setRecargas([]); // Set empty array on error
        }
    };

    const handleUpdateEstado = async (idRecarga, estado) => {
        setLoading(true);
        try {
            const userId = localStorage.getItem('usuario_id');
            const response = await fetch(`https://api.99envios.app/api/online/recargas/actualizar-recarga/${userId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    id_recarga: idRecarga,
                    estado: estado
                })
            });

            const data = await response.json();
            if (!response.ok) throw new Error('Error al actualizar la recarga');

            setMessage(data.success || `Recarga ${estado} exitosamente`);
            fetchRecargas(); // Refresh table data
        } catch (error) {
            setMessage('Error: ' + error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
        <NavbarAdminMex title={"Recargas"} />
            <div className="recargas-admin-container-big">
                <div className="recargas-admin-container">
                    <h2>Administración de Recargas</h2>
                    
                    {message && (
                        <div className={`recargas-message ${message.includes('Error') ? 'error' : 'success'}`}>
                            {message}
                        </div>
                    )}

                    <div className="recargas-table-container">
                        <table className="recargas-table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>ID Sucursal</th>
                                    <th>Fecha</th>
                                    <th>Valor</th>
                                    <th>Estado</th>
                                    <th>Tipo</th>
                                    <th>Comprobante</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {recargas.map((recarga) => (
                                    <tr key={recarga.id}>
                                        <td>{recarga.id}</td>
                                        <td>{recarga.id_sucursal}</td>
                                        <td>{recarga.fecha_recarga ? new Date(recarga.fecha_recarga).toLocaleDateString() : ''}</td>
                                        <td>${recarga.valor}</td>
                                        <td>{recarga.estado}</td>
                                        <td>{recarga.tipo_recarga}</td>
                                        <td>
                                            {recarga.comprobante && (
                                                <a href={recarga.comprobante} target="_blank" rel="noopener noreferrer">
                                                    Ver comprobante
                                                </a>
                                            )}
                                        </td>
                                        <td className="recargas-actions">
                                            <button
                                                onClick={() => handleUpdateEstado(recarga.id, 'aprobada')}
                                                className="recargas-button approve"
                                                disabled={loading || recarga.estado !== 'pendiente'}
                                            >
                                                Aprobar
                                            </button>
                                            <button
                                                onClick={() => handleUpdateEstado(recarga.id, 'rechazada')}
                                                className="recargas-button reject"
                                                disabled={loading || recarga.estado !== 'pendiente'}
                                            >
                                                Rechazar
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AdminRecargas;
